import { ReactComponent as BorderRadiusIcon } from 'assets/icons/border_radius.svg';
import { useTranslation } from 'react-i18next';

import { SliderPopover } from '../../ToolbarPopover';

type BorderRadiusProps = {
  onChange: (value: number) => void;
  value?: number;
};

export const BorderRadiusPopover = ({ onChange, value }: BorderRadiusProps) => {
  const { t } = useTranslation('editor_toolbar', { useSuspense: false, keyPrefix: 'border' });
  const label = t('borderRadius.label');

  return (
    <SliderPopover
      value={value ?? 0}
      icon={<BorderRadiusIcon />}
      label={label}
      onChange={onChange}
      suffix={'%'}
      max={100}
      title={label}
      activeIconStyle={{ '& path': { fill: 'upgrade.blue.700' } }}
    />
  );
};
